import React from 'react'
import { ButtonProps } from 'antd/lib/button/button'
import cl from 'classnames'

import ButtonBase from 'Shared/atoms/ButtonBase'
import Icon, { IconType } from 'Shared/atoms/Icon'

import styles from './styles.module.scss'

export type BtnType = 'primary' | 'secondary' | 'link' | 'danger' | 'warning' | 'notification'

const typeMap = {
	primary: styles.primaryBtn,
	secondary: styles.secondaryBtn,
	danger: styles.dangerBtn,
	link: styles.linkBtn,
	warning: styles.warningBtn,
	notification: styles.notificationBtn
}

type EnchancedButtonProps = ButtonProps & {
	btnType?: BtnType
	iconType?: IconType
}

export type CustomButtonProps = Omit<EnchancedButtonProps, 'size'> & {
	size?: ButtonProps['size'] | 'xSmall'
}

const Button: React.FC<CustomButtonProps> = ({
	className,
	btnType,
	iconType,
	children,
	icon,
	...props
}) => {
	const typeClassName = typeMap[btnType || 'primary']
	const iconComponent = iconType ? (
		<Icon type={iconType} className={styles.icon} />
	) : icon ? (
		icon
	) : null

	return (
		<ButtonBase {...props} className={cl(typeClassName, className)} icon={iconComponent}>
			{children}
		</ButtonBase>
	)
}

export default Button
